import React, { useState, useEffect } from 'react'
import ModalActionButton from '../../elements/ModalActionButton';
import PlusIcon from '../../elements/icons/PlusIcon';
import AutocompleteSelect from '../../elements/form/AutocompleteSelect';
import Loader from '../../elements/Loader';
import { useSelector, useDispatch } from 'react-redux';
import { fetchDesignations } from '../../../store/actions/designationActions';
import { updateStaff } from '../../../store/actions/staffActions';

const UpdateStaffDesignations = ({staff, currentDesignations, close}) => {
    const [designations, setDesignations] = useState(currentDesignations || []);
    const [addingNewDesignation, setAddingNewDesignation] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const [selectedDesignations, setSelectedDesignations] = useState([]);

    const staffSelector = useSelector(state => state.staff);
    const designationsSelector = useSelector(state => state.designations);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchDesignations('', 0, 0))

    }, [dispatch]);

    const validateForm = () => {
        const errors = {};
        selectedDesignations.forEach((designation, index) => {
            if (!designation) {
                errors[`designation-${index}`] = 'Designation is required';
            }
        });
        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };


    const updateStaffDesignations = () => {
        if (!validateForm()) {
            return;
        }
        
        const payload = {
            designations: [
                ...designations.map(designation => designation._id),
                ...selectedDesignations]
        };

        console.log(payload)
        dispatch(updateStaff(staff?._id, payload))
    };
    return (
        <div className="w-full">
            {designationsSelector.loadingDesignations ? 
                <Loader />
            : 
                <>
                    {designations.length > 0 ? (
                        <div className="mt-4 mb-4">
                            <p className="text-gray-500 text-sm">Current designations for {staff?.name || 'this staff member'}:</p>
                            {designations.map((designation, index) => (
                                <div className="w-full rounded-lg p-3 transition duration-400 bg-gray-100 flex items-center justify-between my-3">
                                    <p key={index} className="text-gray-800 text-sm font-space-grotesk font-semibold">{designation.name}</p>

                                    <button
                                        type="button"
                                        className="text-gray-500 text-xs hover:bg-gray-200 p-2 rounded-lg font-space-grotesk font-semibold transition duration-200"
                                        onClick={() => {
                                            const updatedDesignations = [...designations];
                                            updatedDesignations.splice(index, 1);
                                            setDesignations(updatedDesignations);
                                        }}
                                    >
                                        Remove
                                    </button>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="text-gray-500 text-xs">No designations assigned to {staff?.name || 'this staff member'} yet. Click on "Add new designation" below to add new designations.</p>
                    )}

                    {addingNewDesignation && <>
                        {selectedDesignations?.map((designation, index) => (
                            <div className="mb-2 flex items-end gap-x-1 pr-3" key={index}>
                                <AutocompleteSelect 
                                    selectOptions={designationsSelector?.designations?.designations?.filter(
                                        (option) => !designations.some((designation) => designation._id === option._id)
                                    )}
                                    inputLabel="Select New Designation"
                                    titleField="name"
                                    displayImage={false}
                                    imageField=""
                                    preSelected={designation}
                                    fieldId="employee-designation"
                                    requiredField={true}
                                    placeholderText="Select a new designation"
                                    hasError={validationErrors[`designation-${index}`]}
                                    // return id of accounts of the selected option
                                    returnFieldValue={(value) => {
                                        const updatedDesignations = [...selectedDesignations];
                                        updatedDesignations[index] = value._id;
                                        setSelectedDesignations(updatedDesignations);
                                    }}
                                />
                                <button
                                    type="button"
                                    className="text-gray-500 text-xs hover:bg-gray-200 p-2 rounded-lg mb-2 font-space-grotesk font-semibold transition duration-200"
                                    onClick={() => {
                                        const updatedDesignations = [...selectedDesignations];
                                        updatedDesignations.splice(index, 1);
                                        setSelectedDesignations(updatedDesignations);
                                    }}
                                >
                                    Remove
                                </button>
                        </div>
                        ))}
                    </>}

                    <button onClick={() => {
                            setSelectedDesignations([...selectedDesignations, '']);
                            setAddingNewDesignation(true)
                        }} className="w-full rounded-lg p-3 transition duration-200 hover:bg-gray-50  text-center flex items-center justify-center text-sm border border-dashed border-gray-300 hover:border-gray-600 mt-4 font-space-grotesk font-semibold">
                        <PlusIcon className={`w-4 h-4`} />
                        Add new designation
                    </button>
                </>
            }

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update Designations for ${staff?.name || 'Staff'}`}
                    buttonAction={updateStaffDesignations}
                    processing={staffSelector.updatingStaff}
                    disabled={designationsSelector.loadingDesignations}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent transition duration-200 hover:bg-opacity-5 rounded-xl hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
            
            </div>
        </div>
    )
}

export default UpdateStaffDesignations